export default __webpack_public_path__ + "static/media/ContactId.04cfc5b4.svg";